module.exports = __webpack_public_path__ + "static/media/7.51cbe1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/7.png
// module id = 963
// module chunks = 0